// src/features/auth/components/QRCodeDisplay.tsx
import React from 'react';
import { QrCodeIcon } from '@heroicons/react/24/outline';

interface QRCodeDisplayProps {
  qrCode?: string;
  secretKey?: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ qrCode, secretKey }) => {
  if (!qrCode) {
    return (
      <div className="flex flex-col items-center justify-center py-12 space-y-4">
        <QrCodeIcon className="h-16 w-16 text-theme-text-secondary dark:text-dark-theme-text-secondary" />
        <p className="text-theme-text-secondary dark:text-dark-theme-text-secondary">
          Loading QR code...
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Instructions */}
      <div className="text-center">
        <h4 className="text-lg font-medium text-theme-text dark:text-dark-theme-text mb-2">
          Scan QR Code
        </h4>
        <p className="text-sm text-theme-text-secondary dark:text-dark-theme-text-secondary">
          Open your authenticator app and scan this QR code to add your account
        </p>
      </div>

      {/* QR Code Container */}
      <div className="flex justify-center">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700">
          <img
            src={qrCode}
            alt="Two-Factor Authentication QR Code"
            className="w-48 h-48 mx-auto"
            style={{ imageRendering: 'pixelated' }}
          />
        </div>
      </div>

      {/* QR Code Info */}
      <div className="bg-theme-bg-secondary dark:bg-dark-theme-bg-secondary rounded-md p-4">
        <div className="flex items-start space-x-3">
          <QrCodeIcon className="h-5 w-5 text-primary-light dark:text-primary-dark mt-0.5 flex-shrink-0" />
          <div className="space-y-2">
            <h5 className="text-sm font-medium text-theme-text dark:text-dark-theme-text">
              How to scan:
            </h5>
            <ul className="text-xs text-theme-text-secondary dark:text-dark-theme-text-secondary space-y-1">
              <li>• Open your authenticator app</li>
              <li>• Tap "Add Account" or "+" button</li>
              <li>• Choose "Scan QR Code"</li>
              <li>• Point your camera at this code</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Troubleshooting */}
      <div className="text-center">
        <p className="text-xs text-theme-text-secondary dark:text-dark-theme-text-secondary">
          Can't scan the code?{' '}
          <button className="text-primary-light dark:text-primary-dark hover:underline">
            Try manual entry instead
          </button>
        </p>
      </div>
    </div>
  );
};

export default QRCodeDisplay;
